document.addEventListener('DOMContentLoaded', () => {
  const galleries = document.querySelectorAll('product-media-gallery');

  galleries.forEach(gallery => {
    const swiper = gallery.querySelector('.swiper-main')?.swiper;
    if(!swiper) return;

    const tryPlay = () => {
      const slide = swiper.slides[swiper.activeIndex];
      if (!slide) return;

      const video = slide.querySelector('video');
      if (!video) return;

      video.muted = true;
      video.autoplay = true;

      const p = video.play();
      if (p && p.catch) p.catch(()=>{});
    };

    swiper.on('slideChange', tryPlay);
    tryPlay();
  });
});
